import { render, staticRenderFns } from "./FormTuoteryhma.vue?vue&type=template&id=165e43ca&scoped=true&"
import script from "./FormTuoteryhma.vue?vue&type=script&lang=js&"
export * from "./FormTuoteryhma.vue?vue&type=script&lang=js&"
import style0 from "./FormTuoteryhma.vue?vue&type=style&index=0&id=165e43ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165e43ca",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('165e43ca')) {
      api.createRecord('165e43ca', component.options)
    } else {
      api.reload('165e43ca', component.options)
    }
    module.hot.accept("./FormTuoteryhma.vue?vue&type=template&id=165e43ca&scoped=true&", function () {
      api.rerender('165e43ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormTuoteryhma.vue"
export default component.exports